import o from "./tokens.json.mjs";
import { getKeys as r } from "./types3.mjs";
const i = o.brand, p = () => {
  const t = i.lineHeights;
  return r(t).reduce(
    (n, s) => {
      const e = t[s].value;
      return n[s] = e.toUpperCase() === "AUTO" ? "normal" : `${e}${e.includes("%") ? "" : "px"}`, n;
    },
    {}
  );
};
export {
  p as compileLineHeights
};
//# sourceMappingURL=compileLineHeights.mjs.map
